import { useEffect, useState } from 'react';
import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import ModalImgProduto from './ModalImgProduto';
import noImage from '../images/noimage.png';

function CardImgProduto({ produto }){
    const [imgProduto, setImgProduto] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [itemSel, setItemSel] = useState(null);
    
    const abrirModal = (item) => {
        setItemSel(item);
        setOpenModal(true);
    };

    const fecharModal = () => {
        setOpenModal(false);
    };

    const renderImage = (item)=>{
        let newImg = item.imagem;

        if(newImg !== null){
            setImgProduto(newImg);
        }else{
            setImgProduto(noImage);
        }
    };

    useEffect(()=>{
        renderImage(produto);
    }, [produto]);

    return (
        <>
        <Card sx={{ display: 'flex', width: '100%' }}>
            <CardMedia 
                component="img"
                sx={{ width: 80, cursor: 'pointer' }}
                image={imgProduto}
                alt={produto.nm_produto}
                onClick={()=>abrirModal(produto)}
            />
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                <CardContent sx={{ display: 'flex', flex: '1 0 auto', width: '100%', flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography component="div" sx={{ fontWeight: 'bold', fontSize: 14, }}> {produto.nome} </Typography>
                </CardContent>
            </Box>
        </Card>

        <ModalImgProduto 
            open={openModal} 
            onClose={fecharModal} 
            item={itemSel} 
        />
        </>
    );
}

export default CardImgProduto;